import { Category } from '@modules/common/types';

export const CATEGORY_ORDER_PRIORITY_ARRAY = [
  Category.Improvement,
  Category.Complaint,
  Category.Help,
  Category.Praise,
  Category.Uncategorized,
];
